import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 font-heading">
                69视频
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              69视频平台提供西瓜视频免费、91在线视频等影视在线观看入口，海量电影大全、电视剧全集、综艺节目高清播放不卡顿。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  版权声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                <span>contact@69shipin.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line mt-0.5 text-foreground-500"></i>
                <span>400-888-6969</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                <span>北京市朝阳区光华路69号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 69视频. All rights reserved. 本站内容仅供学习交流使用。
          </p>
          <p className="text-xs text-foreground-500">
            ICP备案号：京ICP备2026069000号
          </p>
        </div>
      </div>
    </footer>
  );
}